import React from "react";
import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";
import {Typography} from "../../../../designSystem/components/Typography";
import {LinkButton} from "../../../../designSystem/components/LinkButton";

import {FormPageLayout} from "../../../../components/layout/FormPageLayout";

const RESOURCE_MAP = 'https://www.google.com/maps/d/u/2/edit?mid=17qioEXavTOt8i49G6-6HEnN6CyYqEKo&amp;ll=22.34413177007981%2C120.59252780000004&amp;z=10'
const RESERVATION_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSd8vUdKz-JhW1vk78xKY4DV6SCcFr-0m_Jumygwo_Q0tt2knQ/viewform'

export const BsrsInfoFeature = () => (
  <FormPageLayout
    height={NAVIGATION_BAR_HEIGHT.LARGE}
    body={
      <div className="p-6 flex flex-col flex-1 gap-6">
        <Typography variant="title">
          相關資源連結
        </Typography>
        <div className="flex flex-col gap-4">
          <LinkButton
            label="屏東縣心理衛生資源地圖"
            onClick={() => window.open(RESOURCE_MAP, '_blank')}
          />
          <LinkButton
            label="心理諮詢預約網址"
            onClick={() => window.open(RESERVATION_LINK, '_blank')}
          />
        </div>
      </div>
    }
  />
)